import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";
import LandingPage from "./components/LandingPage";
import AboutPage from "./components/AboutPage";
import ProductsPage from "./components/ProductsPage";
import AchievementsPage from "./components/AchievementsPage";
import DownloadsPage from "./components/DownloadsPage";
import ContactPage from "./components/ContactPage";
import ScrollToTop from "./components/ScrollToTop";
import WhatsAppButton from "./components/WhatsAppButton";

function App() {
  return (
    <HelmetProvider>
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Toaster position="top-right" />
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/products" element={<ProductsPage />} />
          <Route path="/achievements" element={<AchievementsPage />} />
          <Route path="/downloads" element={<DownloadsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="*" element={<LandingPage />} />
        </Routes>
        <WhatsAppButton />
      </BrowserRouter>
    </div>
    </HelmetProvider>
  );
}

export default App;
